import bannersService from '@/src/services/resources/BannersService'
import genericService from '@services/resources/GenericService'
import bannerService from '@/src/services/resources/BannerService'
import salesBannersProxyService from '@/src/services/resources/SalesBannersProxyService'
import salesBannerProxyService from '@/src/services/resources/SalesBannerProxyService'

const serviceBanners = bannersService.build()
const serviceGeneric = genericService.build()
const serviceBanner = bannerService.build()
const serviceSalesBanners = salesBannersProxyService.build()
const serviceSalesBanner = salesBannerProxyService.build()

const state = {
  banners: [],
  currentPage: 1,
  perPage: 20,
  filter: '',
  totalRows: 1,
  loading: false
}

const getters = {
  getBanners: (state) => state.banners,
  getSalesBanners: (state) => state.banners.filter((banner) => banner.source === 'sales'),
  getCurrentPage: (state) => state.currentPage,
  getPerPage: (state) => state.perPage,
  getFilter: (state) => state.filter,
  getTotalRows: (state) => state.totalRows,
  getLoading: (state) => state.loading
}

const mutations = {
  setBanners(state, value) { state.banners = value },
  setCurrentPage(state, value) { state.currentPage = value },
  setPerPage(state, value) { state.perPage = value },
  setFilter(state, value) { state.filter = value },
  setTotalRows(state, value) { state.totalRows = value },
  setLoading(state, value) { state.loading = value }
}

const actions = {
  updateCurrentPage: ({commit}, data) => commit('setCurrentPage', data),
  updatePerPage: ({commit}, data) => commit('setPerPage', data),
  updateFilter: ({commit}, data) => commit('setFilter', data),
  updateTotalRows: ({commit}, data) => commit('setTotalRows', data),
  updateLoading: ({commit}, data) => commit('setLoading', data),
  updateBanners: ({commit}, data) => commit('setBanners', data),

  fetchBanners({commit, state}, filters) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      commit('setBanners', [])

      let data = {
        per_page: state.perPage,
        page: state.currentPage
      }

      if(filters) {
        Object.keys(filters).forEach((key) =>
          (filters[key] == null || filters[key].length === 0) && delete filters[key]
        )
      }

      data = Object.assign(data, filters)
      if(state.filter.length) data.search = state.filter

      Promise.all([
        serviceBanners.search(data),
        serviceSalesBanners.search({})
      ])
        .then(([greennRes, salesRes]) => {
          const greennBanners = (greennRes.urls || []).map((banner) => ({
            ...banner,
            origin: 'Greenn',
            source: 'greenn',
          }))
          const salesBanners = (salesRes || []).map((banner) => ({
            ...banner,
            image_name: banner.image_url ? banner.image_url.split('/').pop() : `Banner Sales #${banner.id}`,
            ativo: null,
            created_at: banner.created_at || null,
            origin: 'Sales',
            source: 'sales',
          }))

          resolve(greennRes)
          commit('setBanners', greennBanners.concat(salesBanners))
          commit('setTotalRows', (greennRes.total || 0) + salesBanners.length)
        })
        .catch(err => {
          console.error(err)
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  activateBanner({dispatch}, id) {
    return new Promise((resolve, reject) => {
      serviceGeneric
        .update({ id, ativo: 1 }, `/activate/banner/${id}`)
        .then((res) => {
          resolve(res)
          dispatch('fetchBanners')
        })
        .catch(err => {
          console.error(err)
          reject(err)
        })
    })
  },
  deactivateBanner({dispatch}, id) {
    return new Promise((resolve, reject) => {
      serviceGeneric
        .update({ id, ativo: 0})
        .then((res) => {
          resolve(res)
          dispatch('fetchBanners')
        })
        .catch(err => {
          console.error(err)
          reject(err)
        })
    })
  },
  showBanner({commit}, id) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      serviceGeneric.read(`show/${id}`)
        .then(res => resolve(res))
        .catch(err => {
          console.error(err)
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  showSalesBanner(context, id) {
    return new Promise((resolve, reject) => {
      serviceSalesBanner.read(id)
        .then(res => resolve(res))
        .catch(err => {
          console.error(err)
          reject(err)
        })
    })
  },
  deleteBanner({dispatch}, dados) {
    return new Promise((resolve, reject) => {
      serviceBanner.destroy(dados)
        .then(res => {
          resolve(res)
          dispatch('fetchBanners')
        })
        .catch(err => {
          console.error(err)
          reject(err)
        })
    })
  },
  createSalesBanner({dispatch, getters}, {attachment, link, order}) {
    return new Promise((resolve, reject) => {
      const data = new FormData()
      data.append('banner', attachment)
      data.append('order', order != null ? order : getters.getSalesBanners.length + 1)
      if (link) data.append('link', link)

      serviceSalesBanner.create(data)
        .then(res => {
          resolve(res)
          dispatch('fetchBanners')
        })
        .catch(err => reject(err))
    })
  },
  updateSalesBannerOrder({dispatch}, {id, order}) {
    return new Promise((resolve, reject) => {
      serviceSalesBanners.update({ order }, id)
        .then(res => {
          resolve(res)
          dispatch('fetchBanners')
        })
        .catch(err => reject(err))
    })
  },
  deleteSalesBanner({dispatch}, id) {
    return new Promise((resolve, reject) => {
      serviceSalesBanner.destroy({ id })
        .then(res => {
          resolve(res)
          dispatch('fetchBanners')
        })
        .catch(err => {
          console.error(err)
          reject(err)
        })
    })
  }
}

export {
  state,
  getters,
  mutations,
  actions
}
